import api from "@/api";
import Logical2DQuestionSelector from "@/components/editor/Logical2DQuestionSelector.vue";
import LogicalReasoning2DQuestion from "@/components/subject/LogicalReasoning2d/LogicalReasoning2DQuestion.vue";
export default {
  name: "Logical2DQuestionEditor",
  components: {
    LogicalReasoning2DQuestion,
    Logical2DQuestionSelector
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      questions: [],
      typeMap: {},
      drawer: false,
      updateIndex: 0
    };
  },
  methods: {
    toAdd(idx) {
      this.updateIndex = idx;
      this.drawer = true;
    },
    onSelected(qid) {
      api.updateTplQuestionId({
        tplId: this.data.id,
        updateIndex: this.updateIndex,
        questionId: qid
      }).then(() => {
        this.drawer = false;
        this.fetchQuestions();
      });
    },
    fetchQuestions() {
      api.previewTplQuestion(this.data.id).then(ret => {
        this.questions = ret;
      });
    },
    init() {
      this.fetchQuestions();
      api.getLogicalQuestionTypeMap().then(ret => {
        this.typeMap = ret;
      });
    }
  },
  mounted() {
    this.init();
  }
};